import React from 'react';
// import logo from './logo.svg';
//import './App.css';
import GestFidApp from './components/GestFid/GestFidApp';

function App() {
  return (
    <div className='App'>
      <GestFidApp />
    </div>
  );
}

export default App;
